// extracted by mini-css-extract-plugin
export default {"logo":"SetPassword_logo__6+zOp"};